// Lightweight, pragmatic email validation shared by the forms (client) and the
// /api/contact + /api/leads endpoints (server). Not full RFC 5322 — it rejects
// the obviously-malformed (no @, no dot in domain, whitespace) without falsely
// rejecting normal addresses.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(value: string): boolean {
  const v = (value ?? "").trim();
  return v.length > 0 && v.length <= 254 && EMAIL_RE.test(v);
}
